import React from "react";

const NoInternet: React.FC = () => {
  return (
    <div className="text-center text-primary my-10">
      <p className="text-5xl">No internet connection</p>
      <button
        className="text-3xl text-primary mt-5 px-8 py-4 rounded-2xl duration-150 hover:scale-95 border-2 border-primary"
        onClick={() => {
          window.location.reload();
        }}
        aria-label="Reload page"
      >
        Reload page
      </button>
    </div>
  );
};

export default NoInternet;
